import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MarketCommonApi from '../../../API/market/common-api';
import SuppliesApi from '../../../API/shipment/supplies-api';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../components/Basic/Table';
import { H1, Text } from '../../../components/Basic/WrapsStyle';
import { MARKETS_ALL, MARKETS_MAP, TO_SUPPLY, TYPE_BUTTONS, WAREHOUSE_LIST } from '../../../constans';
import CreateSupplyPopUp from './CreateSupplyPopUp';
import styles from './styles.module.scss';
import SuppliesGroupLine from './SupplyLine';
import WarehouseSelect from './WarehouseSelect';

const width = ['40px', '140px', '150px', '200px', '70px', '120px', '300px', '85px'];

const SKLAD_LIST = [{ warehouse: 'Не выбран', name: undefined }, ...WAREHOUSE_LIST, { warehouse: 'Маркетплейс', name: 'mp' }];
const FILTER = {
  0: '',
  1: 'wb',
};

const MAP_SKLAD = {
  msk: 'Москва',
  ekb: 'Екатеринбург',
  mp: 'Маркетплейс',
};

const MARKET_NAME = {
  ozon: 'Ozon',
  yandex: 'Yandex',
  wb: 'Wb',
  megamarket: 'Megamarket',
  avito: 'Avito',
  Ozon: 'Ozon',
  Yandex: 'Yandex',
  Wb: 'Wb',
  Sber: 'Megamarket',
};

function SuppliesPage() {
  const [create, setCreate] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, supply: {} });
  const [address, changeAddress] = useState('');
  const [skladName, setSkladName] = useState(SKLAD_LIST[0]);
  const [count, setCount] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(50);
  const [date, setDate] = useState(null);
  const [shopsWbInfo, setShopsWbInfo] = useState(MARKETS_ALL['wb'].map(s => ({ shop: s })));
  // const [deliveryDate, setDeliveryDate] = useState(moment().add(1, 'days'));

  const [shop, setShop] = useState(MARKETS_ALL['wb'][0]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehousesCoef, setWarehousesCoef] = useState({});
  const [selectedWarehouse, setSelectedWarehouse] = useState({});
  const [supplies, setSupplies] = useState([]);
  const [suppliesSelect, setSuppliesSelect] = useState({});
  const user = useSelector((store) => store.user);
  const packageMethods = useSelector((store) => store.packaging);


  const onClickCreate = () => {
    setCreate(true);
  };

  const changeSuppliesSelect = (number) => {
    if (suppliesSelect[number]) {
      const s = suppliesSelect;
      delete s[number];
      setSuppliesSelect({ ...s });
    } else {
      setSuppliesSelect({ ...suppliesSelect, [number]: true });
    }
  };

  const loadSupplies = () => {
    SuppliesApi.getSupplies({ data: { market: FILTER[tab], limit: parseInt(show), skladName: skladName.name, shipmentDate: date } }).then((r) => setSupplies(r.supplies));
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onCloseDelete = () => {
    loadSupplies();
  };

  useEffect(() => {
    loadSupplies();

  }, [tab, show, skladName.name, date]);

  useEffect(() => {
    MarketCommonApi.getShopsInfo({ data: { market: 'wb' } })
      .then(r => setShopsWbInfo(r.shopsInfo))
    SuppliesApi.getWarehouses({ data: {} }).then(r => {
      setWarehouses(r.warehouses)
      setWarehousesCoef(r.warehousesCoef)
    })
  }, []);


  const colorByPercent = (perc) => {
    if (perc >= 1.6) return '#860000ff'
    if (perc >= 1.4) return '#8d6301ff'
    if (perc >= 1.2) return '#99aa00ff'
    if (perc >= 1) return '#005900ff'
    return '#000000ff'
  }

  const supplies_ids = Object.keys(suppliesSelect);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <H1>Поставки</H1>
        <div style={{ display: 'inline-flex', width: '100%' }}>
          <Column style={{ minWidth: '1350px', flexGrow: '3' }}>


            <WhiteBlock className={styles.search_block}>
              <Row className={styles.navigate_table}>
                <NavTabs
                  open_tab={tab}
                  tabs={['Все поставки', 'Wildberries']}
                  num={count}
                  style_tab={styles.style_tab}
                  onChange={onChangeTab}
                />
              </Row>
              <Row spaceBetween={true} style={{ marginTop: '25px' }}>
                <Row style={{ height: '40px' }}>
                  <Select
                    label="Показать на странице"
                    select={show}
                    list={['10', '20', '50', '100', '150', '200', '500', '1000']}
                    onSelect={(v) => setShow(v)}
                    width="150px"
                    style={{ marginRight: '15px' }}
                  />

                  <Column style={{ marginRight: '15px' }}>
                    <InputLabel>Дата отгрузки</InputLabel>
                    <Row style={{ position: 'relative', width: '150px' }}>
                      <DateInput value={date} className={styles.calendar} onChange={(v) => setDate(v)} />
                      <Button className={styles.close_button} onClick={() => setDate(null)}>
                        <img src={close} style={{ width: '15px' }} />
                      </Button>
                    </Row>
                  </Column>
                  {(isOwner || user.role === 'user') && (
                    <Button style={{ margin: '10px 0 0 30px' }} type={TYPE_BUTTONS.GREEN} onClick={onClickCreate}>
                      Создать поставку
                    </Button>
                  )}
                  {supplies_ids.length > 1 && (
                    <Row>
                      <a
                        href={TO_SUPPLY(supplies_ids.join('&'))}
                        // target={'_blank'} 
                        style={{ marginLeft: '20px', marginTop: '10px' }}>
                        <Button
                          type={TYPE_BUTTONS.BLUE}
                        >
                          Открыть совместно
                        </Button>
                      </a>
                      <Button
                        style={{ marginLeft: '10px', marginTop: '10px' }}
                        type={TYPE_BUTTONS.BLUE}
                        onClick={async (v) => {
                          const r = await SuppliesApi.changeSupplies({ data: { supplyIds: supplies_ids.map(s => +s), action: 'make_group' } })
                          loadSupplies()
                        }}
                      >
                        Создать группу
                      </Button>
                    </Row>
                  )}
                </Row>
              </Row>
            </WhiteBlock>


            <Table>
              <TableHeader whiteHeader>
                <HeaderTitle width={width[0]} />
                <HeaderTitle width={width[4]}>Id Группы</HeaderTitle>
                <HeaderTitle width={width[1]}>Площадки</HeaderTitle>
                {isOwner && <HeaderTitle width={width[4]}></HeaderTitle>}
                <HeaderTitle width={width[2]} centerText>Склады</HeaderTitle>
                <HeaderTitle width={width[5]} centerText>Количество заказов</HeaderTitle>
                <HeaderTitle width={width[7]} style={{ fontSize: '11px' }} centerText>Закуплено</HeaderTitle>
                <HeaderTitle width={width[7]} style={{ fontSize: '11px' }} centerText>Обработано</HeaderTitle>
                <HeaderTitle width={width[7]} style={{ fontSize: '11px' }} centerText>Принято</HeaderTitle>
                <HeaderTitle width={width[5]} centerText>Количество коробов</HeaderTitle>
                {/* <HeaderTitle width={width[2]} centerText>Статус</HeaderTitle> */}
                <HeaderTitle width={width[1]} centerText>Создатель</HeaderTitle>
                <HeaderTitle width={width[0]} />
                <HeaderTitle width={width[6]} centerText>Описание поставок</HeaderTitle>
              </TableHeader>
              {(supplies || []).map((group) => {
                return (
                  <SuppliesGroupLine
                    key={group._id}
                    suppliesGroup={group}
                    width={width}
                    MARKET_NAME={MARKET_NAME}
                    isOwner={isOwner}
                    onCloseDelete={onCloseDelete}
                    changeSuppliesSelect={changeSuppliesSelect}
                    suppliesSelect={suppliesSelect}
                    loadSupplies={loadSupplies}
                  />
                );
              })}
            </Table>
          </Column>

          <Column style={{ flexBasis: 0, marginLeft: '30px' }}>
            <WhiteBlock title='Индекс локализации'>
              <Row style={{ justifyContent: 'space-around' }}>
                {shopsWbInfo.map(shopInfo => (
                  <Row key={shopInfo.shop}  >
                    <Column>
                      <Text style={{ alignSelf: 'center', color: '#310744ae' }} fontWeight={'bold'} fontSize={'18px'}>{shopInfo.shop}</Text>
                      <hr style={{ width: '100%', marginBottom: '10px', color: '#000000ad' }} />
                      <Input
                        color={colorByPercent(shopInfo.localization_index)}
                        fontSize='17px'
                        center={true}
                        value={shopInfo.localization_index}
                        onBlur={async (v) => {
                          await MarketCommonApi.changeShop({ data: { shop: shopInfo.shop, field: 'localization_index', value: +v } })
                          await MarketCommonApi.getShopsInfo({ data: { market: 'wb' } })
                            .then(r => setShopsWbInfo(r.shopsInfo))
                        }}
                      />
                    </Column >
                    <div style={{ margin: '0 12px', borderRight: '1px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  </Row>
                ))}
              </Row>
            </WhiteBlock>
            <WhiteBlock title='Индекс распределения продаж'>
              <Row style={{ justifyContent: 'space-around' }}>
                {shopsWbInfo.map(shopInfo => (
                  <Row key={shopInfo.shop}  >
                    <Column>
                      <Text style={{ alignSelf: 'center', color: '#310744ae' }} fontWeight={'bold'} fontSize={'18px'}>{shopInfo.shop}</Text>
                      <hr style={{ width: '100%', marginBottom: '10px', color: '#000000ad' }} />
                      <Input
                        color={colorByPercent(shopInfo.irp)}
                        fontSize='17px'
                        center={true}
                        value={shopInfo.irp}
                        onBlur={async (v) => {
                          await MarketCommonApi.changeShop({ data: { shop: shopInfo.shop, field: 'irp', value: +v } })
                          await MarketCommonApi.getShopsInfo({ data: { market: 'wb' } })
                            .then(r => setShopsWbInfo(r.shopsInfo))
                        }}
                      />
                    </Column >
                    <div style={{ margin: '0 12px', borderRight: '1px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  </Row>
                ))}
              </Row>
            </WhiteBlock>
            <WhiteBlock className={styles.search_block}>
              <div style={{ fontSize: '23px', color: '#000000ad', marginBottom: '15px' }}>Проверка доступности</div>
              <Row style={{}}>

                <WarehouseSelect
                  label={'Склад'}
                  style={{ marginRight: '30px' }}
                  width={"400px"}
                  warehouses={warehouses}
                  warehouse={selectedWarehouse.name || ''}
                  onChange={(v) => setSelectedWarehouse({ ...v, dateCoef: warehousesCoef[v.ID] })}
                />
                <Select
                  list={MARKETS_ALL['wb']}
                  select={shop}
                  label="Магазин"
                  onSelect={(v) => setShop(v)}
                  width={'150px'}
                />

              </Row>

              <div style={{ marginTop: '30px' }}>
                {Object.entries({
                  'ID склада': selectedWarehouse.ID,
                  'Название склада': selectedWarehouse.name,
                  'Адресс': selectedWarehouse.address,
                  'Время работы': selectedWarehouse.workTime,
                }).map(([key, value]) => {
                  return (
                    <div key={key}><span style={{ color: '#0000009f' }}>{key}:</span> {value}</div>
                  )
                })}

              </div>

              <Row style={{ marginTop: '20px' }}>
                <SendButton
                  // multiple={true}
                  sendApi={SuppliesApi.checkSupplyList}
                  sendData={{ data: { shop: MARKETS_MAP[shop], warehouseId: selectedWarehouse.ID }, options: { download: true } }}
                  style={{ marginTop: '15px' }}
                  disabled={!(selectedWarehouse.name && shop)}
                >
                  Проверить артикулы
                </SendButton>
                <Button style={{ margin: '15px 0 0 15px' }} type={TYPE_BUTTONS.WHITE}
                  onClick={() => {
                    SuppliesApi.excelTemplateToCheck({})
                  }}
                >
                  Шаблон
                </Button>
              </Row>

              {/* <div style={{ marginTop: '15px' }}>

                <DateInput
                  value={deliveryDate}
                  className={styles.calendar}
                  onChange={(v) => setDeliveryDate(v)}
                />
              </div> */}

              <div style={{ marginTop: '20px', width: '100%', maxHeight: '1000px', overflowY: 'auto' }}>
                {selectedWarehouse.name && selectedWarehouse.dateCoef.map(d => {
                  return (
                    <div key={d.date} style={{ marginTop: '20px' }}>
                      {Object.entries({
                        'Дата': moment(d.date).format('YYYY-MM-DD'),
                        'Коэффициент приёмки': (d.coefficient === -1 || !d.allowUnload) ? 'НЕДОСТУПНА' : d.coefficient === 0 ? 'Бесплатно' : 'Платная',
                        ...(d.coefficient !== -1 && d.allowUnload && {
                          'Хранение первого / посл. литра / коэффициент': `${d.storageBaseLiter} / ${d.storageAdditionalLiter} / ${d.storageCoef}`,
                          'Логистика первого / посл. литра / коэффициент': `${d.deliveryBaseLiter} / ${d.deliveryAdditionalLiter} / ${d.deliveryCoef}`
                        })
                      }).map(([key, value]) => {
                        return (<>
                          <div key={key}><span style={{ color: '#0000009f' }}>{key}:</span> {value}</div>
                        </>)
                      })}
                      <hr style={{ width: '90%', backgroundColor: '#45454542', height: '1px', border: 'none' }} />
                    </div>)
                })}
              </div>

            </WhiteBlock>
          </Column>
        </div>

      </Content >
      {create && (
        <CreateSupplyPopUp
          close={() => {
            setCreate(false);
            loadSupplies();
          }}
        />
      )
      }
    </>
  );
}

export default SuppliesPage;
